// extracted by mini-css-extract-plugin
export default {"feature":"style_feature__1SjjI","dot":"style_dot__nQZl9","icon":"style_icon__XR6G1","text":"style_text__hxhHM"};